import { ReportConfig } from '../../dtos/interfaces/report-config';
import {
    SorterReturnDetailsReportRowDto
} from "../../../services/dtos/reports/sorter/sorter-return-details-report-row.dto";
import moment = require('moment');

function toRecord(d: SorterReturnDetailsReportRowDto): SorterReturnDetailsReportRowDto {
    const r = new SorterReturnDetailsReportRowDto();
    r.timestampUtc = moment.utc(d.timestampUtc).local().format('YYYY-MM-DD h:mm a');
    r.deviceName = d.deviceName;
    r.itemBarcode = d.itemBarcode;
    r.boxId = d.boxId;
    r.expectedBin = d.expectedBin;
    r.itemName = d.itemName;
    r.itemSuccessDisplay = d.itemSuccess ? '' : '×'; // ✖ doesn't work on printed pdf
    return r;
}

export const returnDetailsReport: ReportConfig = {
    id: 'sorter-return-details',
    label: 'Return Details',
    category: 'Sorter',
    showHeader: true,
    columns: [
        { key: 'timestampUtc',       label: 'Timestamp',      width: '18%' },
        { key: 'deviceName',         label: 'Device Name',    width: '32%' },
        { key: 'itemBarcode',        label: 'Item Barcode ',  width: '16%' },
        { key: 'expectedBin',        label: 'Expected Bin',   width: '8%'  },
        { key: 'boxId',              label: 'Box ID',         width: '8%',  truncate: true },
        { key: 'itemName',           label: 'Item Name',      width: '14%', truncate: true },
        { key: 'itemSuccessDisplay', label: 'Item Success',   width: '4%',  align: 'center', hideLabel: true  },
    ],
    endpoint: 'sorter-return-details-report',
    mapRows: (rows, search) => rows.map(toRecord),
};


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/reports/definitions/sorter/return-details.report.ts